// Calls to Tiny Legends' Worker. Every /v1 call that needs a player sends a fresh Firebase ID token.
import { API_BASE } from './config';

export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number, public body: Record<string, unknown> = {}) {
    super(message);
  }
  /** Server or network trouble (worth a fallback or a retry), as opposed to a deliberate refusal. */
  get transient(): boolean { return this.status === 0 || this.status >= 500; }
}

export interface ApiOptions {
  method?: 'GET' | 'POST';
  body?: unknown;
  /** Returns the current user's ID token; omitted for public routes. */
  token?: () => Promise<string>;
}

export async function api<T>(path: string, opts: ApiOptions = {}): Promise<T> {
  const headers: Record<string, string> = {};
  if (opts.body !== undefined) headers['content-type'] = 'application/json';
  if (opts.token) headers.authorization = `Bearer ${await opts.token()}`;
  let res: Response;
  try {
    res = await fetch(API_BASE + path, {
      method: opts.method ?? (opts.body !== undefined ? 'POST' : 'GET'),
      headers,
      body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    });
  } catch (e) {
    throw new ApiError('network', 'Network error. Check your connection.', 0);
  }
  const json = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    const code = typeof json.error === 'string' ? json.error : `http_${res.status}`;
    const message = typeof json.message === 'string' ? json.message : code;
    throw new ApiError(code, message, res.status, json);
  }
  return json as T;
}
